import { ApplicantUserCitizenship } from "../../../../generated";
import { ProfileHeader } from "./profile-header";
import { Country } from "../../../../types/country";
import { CountryView } from "../../../shared/country-view";

const TITLE = "Citizenship Details";

interface ProfileCitizenshipViewProps {
  citizenship: ApplicantUserCitizenship | null | undefined;
  countries: Country[];
  onEditToggle: () => void;
}

export const ProfileCitizenshipView: React.FC<ProfileCitizenshipViewProps> = ({
  citizenship,
  onEditToggle,
}) => {
  const countryCodes = Array.isArray(citizenship?.currentCitizenOf) 
    ? citizenship.currentCitizenOf.filter((code): code is string => code !== null && code !== undefined) 
    : [];
  return (
    <div className="flex flex-col space-y-4">
      <ProfileHeader title={TITLE} onEdit={onEditToggle} />
      <CountryView countryCode={countryCodes} label="Current Citizen of" layout="vertical"/>
    </div>
  );
};
